<button
  (click)="onButtonClick($event)"
  [class.cursor-pointer]="!isDisabled"
  [class.opacity-50]="isDisabled"
  [ngClass]="[variant, padding]"
  [disabled]="isDisabled"
  [type]="type"
  class="pl-button relative block h-[inherit] w-full place-content-center rounded-lg border antialiased transition duration-300 ease-out focus:outline-none"
>
  <div class="flex h-[inherit] items-center justify-center gap-1 self-center font-sans text-lg font-extrabold">
    <ng-content></ng-content>
  </div>
</button>
